module.exports = __webpack_public_path__ + "img/logo_gray.a961e3ff.svg";